<form class="space-y-3 sm:space-y-4 w-full max-w-full" (submit)="crear($event)">
  <div>
    <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">Nombre</label>
    <input
      [formField]="$any(formTipoPago.nombre)"
      class="w-full text-sm sm:text-base border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
      placeholder="Ingrese el nombre"
    />
  </div>

  <div>
    <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1"
      >Tipo de transacción</label
    >
    <app-select
      [filter]="true"
      filterBy="label,value"
      emptyFilterMessage="No se encontraron tipos de transacción."
      [formField]="$any(formTipoPago.tipo_transaccion)"
      [options]="opcionesTipoTransaccion()"
      [loading]="!opcionesTipoTransaccion().length"
      class="w-full"
    />
  </div>

  <div class="flex flex-col-reverse sm:flex-row justify-end gap-2 sm:gap-2 pt-3 sm:pt-4">
    <button
      type="button"
      class="w-full sm:w-auto px-4 py-2.5 rounded-lg bg-gray-100 text-gray-700 hover:bg-gray-200 font-medium active:scale-95 transition-all text-sm sm:text-base"
      (click)="cancelar()"
    >
      Cancelar
    </button>
    <button
      type="submit"
      class="w-full sm:w-auto px-4 py-2.5 rounded-lg bg-blue-600 text-white hover:bg-blue-700 font-medium active:scale-95 transition-all text-sm sm:text-base"
    >
      Crear
    </button>
  </div>
</form>
